import React, { memo } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  StyledEngineProvider,
} from '@mui/material';
import Biotif from '@styles/Font';
import classNames from 'classnames';
import { DropdownProps } from './Dropdown.types';
import styles from './styles.module.scss';

// custom styles for mui
const accordionStyle = {
  boxShadow: 'none',
  backgroundColor: 'transparent',
  borderBottom: '0.1rem solid #e5e5e5',
  '&:before': {
    display: 'none',
  },
  ':last-of-type': {
    borderRadius: 0,
  },
  marginBottom: '2.6rem',
};

const accordionDetailsStyle = {
  flexDirection: 'row-reverse',
  padding: '0 0.6rem',
  alignItems: 'flex-start',
};

const Dropdown = memo<DropdownProps>(({ question, answer }) => (
  <StyledEngineProvider injectFirst>
    <Accordion sx={accordionStyle} disableGutters>
      <AccordionSummary
        id={question}
        aria-controls={question}
        expandIcon={<KeyboardArrowDownIcon className={styles.arrow} />}
        className={styles.accordionSummary}
      >
        <Typography className={classNames(Biotif.className, styles.accordionQuestion)}>
          {question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={accordionDetailsStyle}>
        <Typography className={classNames(Biotif.className, styles.accordionAnswer)}>
          {answer}
        </Typography>
      </AccordionDetails>
    </Accordion>
  </StyledEngineProvider>
));

export default Dropdown;
